export interface OnboardingSlide {
  titleKey: string;
  descriptionKey: string;
  icon?: string;
  video?: string;
  gradientColors?: string[];
  type?: 'intro' | 'feature' | 'balance';
}

export const onboardingSlides: OnboardingSlide[] = [
  {
    titleKey: 'onboarding.slides.welcome.title',
    descriptionKey: 'onboarding.slides.welcome.description',
    icon: "👋",
    type: 'intro',
    gradientColors: ['#2c3e50', '#4ca1af']
  },
  {
    titleKey: 'onboarding.slides.cRoll.title',
    descriptionKey: 'onboarding.slides.cRoll.description',
    icon: "📱",
    type: 'feature',
    gradientColors: ['#3a6186', '#89253e']
  },
  {
    titleKey: 'onboarding.slides.podcastSeries.title',
    descriptionKey: 'onboarding.slides.podcastSeries.description',
    icon: "🎙️",
    type: 'feature',
    gradientColors: ['#654ea3', '#eaafc8']
  },
  {
    titleKey: 'onboarding.slides.podcastMoments.title',
    descriptionKey: 'onboarding.slides.podcastMoments.description',
    icon: "⭐",
    type: 'feature',
    gradientColors: ['#ff9966', '#ff5e62']
  },
  {
    titleKey: 'onboarding.slides.aiCaptions.title',
    descriptionKey: 'onboarding.slides.aiCaptions.description',
    icon: "💬",
    type: 'feature',
    gradientColors: ['#1d4350', '#a43931']
  },
  {
    titleKey: 'onboarding.slides.balance.title',
    descriptionKey: 'onboarding.slides.balance.description',
    icon: "✨",
    type: 'balance',
    gradientColors: ['#141e30', '#243b55']
  }
]; 